/* FRENESI — Minha conta Frenesi (sections/fv-minha-conta.liquid).
 *
 * Busca a conta no ERP pelo proxy do app (/apps/frenesi) e desenha cada tela:
 * visão geral, pedidos, um pedido com rastreio, cashback, perfil olfativo e
 * dados. A navegação é pelo endereço (#pedidos, #pedido/SH-2901…),
 * para o botão «voltar» do celular funcionar e o link de um pedido poder ser
 * aberto direto.
 *
 * Todo texto que vem do ERP passa por `esc` antes de virar HTML.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-fv-conta]');
  if (!raiz) return;

  var principal = raiz.querySelector('[data-mc-principal]');
  var faixa = raiz.querySelector('[data-mc-faixa]');
  var nome = raiz.getAttribute('data-nome') || '';
  var conta = null;
  var faixaOriginal = faixa ? faixa.innerHTML : '';

  // ── Utilidades ─────────────────────────────────────────────────────────
  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function brl(v) {
    var n = Number(v) || 0;
    return 'R$ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  var DIAS = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
  var MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

  function quando(iso) {
    if (!iso) return null;
    // Data sem hora (AAAA-MM-DD) é dia do calendário, não meia-noite UTC.
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    var d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }

  function dd(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function dia(iso) {
    var d = quando(iso);
    return d ? dd(d.getDate()) + '/' + dd(d.getMonth() + 1) : '';
  }

  function diaAno(iso) {
    var d = quando(iso);
    return d ? dia(iso) + '/' + d.getFullYear() : '';
  }

  function hora(iso) {
    var d = quando(iso);
    return d ? dd(d.getHours()) + 'h' + dd(d.getMinutes()) : '';
  }

  function hoje(d) {
    var h = new Date();
    return d.getDate() === h.getDate() && d.getMonth() === h.getMonth() && d.getFullYear() === h.getFullYear();
  }

  function diaCurto(iso) {
    var d = quando(iso);
    if (!d) return '';
    return hoje(d) ? 'Hoje' : dia(iso);
  }

  function diaDaSemana(iso) {
    var d = quando(iso);
    return d ? DIAS[d.getDay()] + ', ' + dia(iso) : '';
  }

  function mesAno(iso) {
    var d = quando(iso);
    return d ? MESES[d.getMonth()] + ' de ' + d.getFullYear() : '';
  }

  function pagamento(meio) {
    return { pix: 'Pix', cartao: 'Cartão de crédito', pagaleve: 'Pix parcelado', boleto: 'Boleto' }[meio] || (meio ? esc(meio) : '');
  }

  // ── Ícones (traço, como o resto do tema) ───────────────────────────────
  function ic(d, t, extra) {
    return '<svg width="' + (t || 18) + '" height="' + (t || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + ((extra && extra.traco) || 1.6) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  var I = {
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    estrela: '<path d="m12 3.6 2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z"/>',
    seta: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    volta: '<path d="M19 12H5M11 6l-6 6 6 6"/>',
    frete: '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>',
    relogio: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    cash: '<circle cx="12" cy="12" r="8.5"/><path d="M14.8 9.2c-.5-.9-1.6-1.4-2.8-1.4-1.6 0-2.8.8-2.8 2s1.1 1.7 2.8 2.1 2.9 1 2.9 2.2-1.3 2-2.9 2c-1.3 0-2.5-.6-3-1.6M12 6.3v1.5M12 16.2v1.5"/>',
    sacola: '<path d="M5 8h14l-1.2 12.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    pin: '<path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21Z"/><circle cx="12" cy="9.5" r="2.5"/>',
    copiar: '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h9"/>',
    externo: '<path d="M7 17 17 7M9 7h8v8"/>',
    balao: '<path d="M20.5 11.6a8.4 8.4 0 0 1-12.3 7.4L3.5 20.5l1.5-4.4a8.4 8.4 0 1 1 15.5-4.5Z"/>',
    troca: '<path d="M4 9h13l-3-3M20 15H7l3 3"/>',
    brilho: '<path d="M12 3l1.8 4.9L19 9.7l-5.2 1.8L12 16.4l-1.8-4.9L5 9.7l5.2-1.8z"/>'
  };

  // ── Situação de um pedido ──────────────────────────────────────────────
  function andando(p) {
    var c = p.rastreio && p.rastreio.status && p.rastreio.status.chave;
    return Boolean(c) && ['entregue', 'cancelado', 'aguardando_pagamento'].indexOf(c) < 0;
  }

  function chip(p) {
    var r = p.rastreio;
    var c = r && r.status ? r.status.chave : p.situacao === 'cancelado' ? 'cancelado' : 'entregue';
    if (c === 'entregue') {
      return '<span class="mc-chip mc-chip--entregue">' + ic(I.check, 13, { traco: 2.4 }) + 'Entregue' + (r && r.entregueEm ? ' em ' + dia(r.entregueEm) : '') + '</span>';
    }
    if (c === 'cancelado') return '<span class="mc-chip mc-chip--neutro">Cancelado</span>';
    if (c === 'aguardando_pagamento') return '<span class="mc-chip mc-chip--neutro">Aguardando pagamento</span>';
    return '<span class="mc-chip mc-chip--caminho"><span class="mc-pulso"></span>' + esc(r.status.titulo) + '</span>';
  }

  function qtd(p) {
    var n = p.itens.reduce(function (s, i) { return s + (i.quantidade || 1); }, 0);
    return n + (n === 1 ? ' perfume' : ' perfumes');
  }

  // ── Fotos dos produtos (da própria loja, pelo handle) ──────────────────
  var produtos = {};

  function produto(handle) {
    if (!handle) return Promise.resolve(null);
    if (!produtos[handle]) {
      produtos[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return produtos[handle];
  }

  function imagem(prod, largura) {
    var src = prod && (prod.featured_image || (prod.images && prod.images[0]));
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (largura || 200);
  }

  function foto(handle, tam, redonda) {
    return '<span class="mc-foto mc-foto--vazia" data-mc-foto="' + esc(handle || '') + '" style="width:' + tam + 'px;height:' + tam + 'px;' + (redonda ? 'border-radius:50%;' : '') + '"></span>';
  }

  function pilha(p, tam) {
    var vistos = {};
    var lista = [];
    p.itens.forEach(function (i) {
      if (i.handle && !vistos[i.handle] && lista.length < 3) {
        vistos[i.handle] = 1;
        lista.push(i.handle);
      }
    });
    return '<span class="mc-pilha">' + lista.map(function (h) { return foto(h, tam, true); }).join('') + '</span>';
  }

  function preencherFotos() {
    principal.querySelectorAll('[data-mc-foto]').forEach(function (el) {
      var handle = el.getAttribute('data-mc-foto');
      if (!handle || el.getAttribute('data-ok')) return;
      el.setAttribute('data-ok', '1');
      produto(handle).then(function (prod) {
        var src = imagem(prod, 240);
        if (!src) return;
        el.classList.remove('mc-foto--vazia');
        el.innerHTML = '<img src="' + esc(src) + '" alt="' + esc(prod.title) + '" loading="lazy">';
      });
    });
  }

  // ── Peças ──────────────────────────────────────────────────────────────
  function etapas(r) {
    if (!r || !r.etapas || !r.etapas.length) return '';
    var n = r.etapas.length;
    var feitas = r.etapas.filter(function (e) { return e.estado === 'feita'; }).length;
    var atual = r.etapas.findIndex(function (e) { return e.estado === 'atual'; });
    var ate = atual > -1 ? atual : feitas - 1;
    var frac = n > 1 ? Math.max(0, ate) / (n - 1) : 0;
    var lis = r.etapas.map(function (e, i) {
      var bola, cls = '', sub = '';
      if (e.estado === 'feita') {
        bola = '<span class="mc-bola mc-bola--feita">' + ic(I.check, 14, { traco: 2.4 }) + '</span>';
        sub = e.quando ? (hoje(quando(e.quando)) ? 'hoje' : dia(e.quando)) : '';
      } else if (e.estado === 'atual') {
        bola = '<span class="mc-bola mc-bola--atual"><span class="mc-pulso"></span></span>';
        cls = 'mc-agora';
        sub = e.chave === 'entregue' && r.previsaoEntrega ? 'até ' + dia(r.previsaoEntrega) : 'agora';
      } else {
        bola = '<span class="mc-bola"></span>';
        cls = 'mc-pendente';
        sub = e.chave === 'entregue' && r.previsaoEntrega ? 'até ' + dia(r.previsaoEntrega) : '';
      }
      return '<li class="' + cls + '">' + bola + '<span><b>' + esc(e.rotulo) + '</b><small>' + esc(sub) + '</small></span></li>';
    }).join('');
    var meia = 'calc(100% / ' + 2 * n + ')';
    return '<div class="mc-etapas">' +
      '<span class="mc-etapas__trilho" style="left:' + meia + ';right:' + meia + '"></span>' +
      '<span class="mc-etapas__feito" style="left:' + meia + ';width:calc((100% - 100% / ' + n + ') * ' + frac.toFixed(4) + ')"></span>' +
      '<ol aria-label="Etapas do pedido">' + lis + '</ol></div>';
  }

  function ultimoEvento(r) {
    var e = r && r.historico && r.historico[0];
    if (!e) return '';
    var d = quando(e.quando);
    var rotulo = d && hoje(d) ? 'Hoje, ' + hora(e.quando) : dia(e.quando) + ', ' + hora(e.quando);
    return '<div class="mc-aviso"><span class="mc-pulso"></span><span><b>' + esc(rotulo) + '</b> · ' + esc(e.texto) + (e.local ? ', ' + esc(e.local) : '') + '</span></div>';
  }

  function previsao(r) {
    if (!r) return '';
    if (r.entregueEm) return 'Entregue em ' + diaDaSemana(r.entregueEm);
    if (r.previsaoEntrega) return 'Chega até ' + diaDaSemana(r.previsaoEntrega);
    return '';
  }

  function cartaoCashback(semExtrato) {
    var cb = conta.cashback;
    var cheio = cb.saldo > 0 ? Math.round((cb.saldo / 0.25) * 100) / 100 : 0;
    var info = cb.saldo > 0
      ? '<span>' + ic(I.relogio, 17) + 'Vale até <b>' + esc(dia(cb.expiraPrimeiro)) + '</b></span>' +
        '<span>' + ic(I.cash, 17) + 'Cobre até 25% dos produtos do pedido</span>' +
        '<span>' + ic(I.sacola, 17) + 'Use tudo numa compra a partir de <b>' + brl(cheio) + '</b></span>'
      : '<span>' + ic(I.cash, 17) + '10% de cada compra volta para cá como crédito</span>' +
        '<span>' + ic(I.relogio, 17) + 'O crédito entra na confirmação do pagamento</span>';
    return '<div class="mc-cb">' +
      '<div class="mc-cab"><span class="mc-olho">Seu cashback</span>' + (semExtrato ? '' : '<a href="#cashback">Ver extrato</a>') + '</div>' +
      '<p class="mc-cb__valor">' + brl(cb.saldo) + '</p>' +
      '<p class="mc-cb__leg">' + (cb.saldo > 0 ? 'disponível para a sua próxima compra' : 'nenhum crédito disponível agora') + '</p>' +
      '<div class="mc-cb__info">' + info + '</div>' +
      '<a class="mc-btn mc-btn--ouro" href="/collections/all">' + (cb.saldo > 0 ? 'Usar no próximo pedido' : 'Ver perfumes') + ic(I.seta, 16, { traco: 2.2 }) + '</a>' +
      '</div>';
  }

  function cartaoPedidoAtual(p) {
    if (!p) {
      return '<div class="mc-card mc-vazio"><span class="mc-olho-escuro">Pedidos</span>' +
        '<p class="mc-h2" style="margin-top:12px">Nenhum pedido a caminho agora</p>' +
        '<p class="mc-sub">Quando você fizer um pedido, a entrega aparece aqui, etapa por etapa.</p>' +
        '<a class="mc-btn mc-btn--escuro" href="/collections/all">Explorar perfumes</a></div>';
    }
    var r = p.rastreio;
    return '<div class="mc-card">' +
      '<div class="mc-cab"><span class="mc-olho-escuro">Pedido a caminho</span>' + chip(p) + '</div>' +
      '<div class="mc-cab" style="margin-top:14px"><div><p class="fv-serif mc-h2" style="font-size:28px">' + esc(p.numero) + '</p>' +
      '<p class="mc-sub" style="margin-top:5px">' + qtd(p) + (p.total != null ? ' · ' + brl(p.total) : '') + '</p></div>' + pilha(p, 46) + '</div>' +
      '<div style="margin-top:24px">' + etapas(r) + '</div>' +
      ultimoEvento(r) +
      '<div class="mc-cab" style="margin-top:22px;flex-wrap:wrap">' +
      (previsao(r) ? '<span style="display:flex;align-items:center;gap:9px;font-size:14px;color:rgb(26 23 21/.7)">' + ic(I.frete, 19) + esc(previsao(r)) + '</span>' : '<span></span>') +
      '<a class="mc-btn mc-btn--escuro mc-btn--p" href="#pedido/' + encodeURIComponent(p.numero) + '">Acompanhar entrega' + ic(I.seta, 15, { traco: 2.2 }) + '</a></div>' +
      '</div>';
  }

  // [dono, 19/10] Os pedidos entregues podem ser avaliados pela conta: o
  // link é o mesmo do e-mail (com a chave), e vem do ERP pronto.
  // [dono, 20/10] Foto ou vídeo recusado na conferência: o mesmo link reabre
  // o envio («o ideal é dar opção para o cliente reavaliar»).
  function aAvaliar(p) { return p.avaliacao && (!p.avaliacao.avaliado || p.avaliacao.reenvio) ? p.avaliacao.link : null; }

  function convidaAvaliar() {
    var p = conta.pedidos.find(aAvaliar);
    if (!p) return '';
    var outra = p.avaliacao.reenvio;
    return '<div class="mc-card mc-avaliar"><div><span class="mc-olho-escuro">' + (outra ? 'Falta pouco para o seu cupom' : 'Sua opinião') + '</span>' +
      (outra
        ? '<p class="fv-serif mc-h2" style="margin-top:8px">Mande outra foto ou vídeo do <span style="white-space:nowrap">' + esc(p.numero) + '</span></p>' +
          '<p class="mc-sub">As suas notas já estão guardadas. Com os decants à vista, a equipe confere de novo e o cupom chega por e-mail.</p></div>'
        : '<p class="fv-serif mc-h2" style="margin-top:8px">Como foram os perfumes do <span style="white-space:nowrap">' + esc(p.numero) + '</span>?</p>' +
          '<p class="mc-sub">Avalie em menos de um minuto. Com foto ou vídeo dos seus decants, você ganha um cupom para a próxima compra.</p></div>') +
      '<a class="mc-btn mc-btn--escuro" href="' + esc(aAvaliar(p)) + '">' + ic(I.estrela, 17) + (outra ? 'Enviar foto ou vídeo' : 'Avaliar pedido') + '</a></div>';
  }

  function linhaPedido(p) {
    return '<a class="mc-linha" href="#pedido/' + encodeURIComponent(p.numero) + '">' + pilha(p, 38) +
      '<span style="min-width:0"><b>' + esc(p.numero) + '</b><small>' + diaAno(p.compradoEm) + ' · ' + qtd(p) + '</small></span>' +
      '<span class="mc-linha__dir">' + (p.total != null ? '<b>' + brl(p.total) + '</b>' : '') + chip(p) + (aAvaliar(p) ? '<em class="mc-tag-avaliar">' + ic(I.estrela, 12, { traco: 2 }) + 'Avaliar</em>' : '') + '</span>' +
      ic(I.seta, 16, { traco: 2 }) + '</a>';
  }

  function listaPedidos(limite, titulo) {
    var lista = conta.pedidos.slice(0, limite || conta.pedidos.length);
    if (!lista.length) {
      return '<div class="mc-card mc-vazio"><p class="fv-serif mc-h2">Você ainda não tem pedidos</p>' +
        '<p class="mc-sub">Seus pedidos aparecem aqui, com o rastreio de cada um.</p>' +
        '<a class="mc-btn mc-btn--escuro" href="/collections/all">Explorar perfumes</a></div>';
    }
    return '<div class="mc-card" style="padding:0;overflow:hidden">' +
      '<div class="mc-cab" style="padding:22px 24px 16px"><h2 class="fv-serif mc-h2">' + esc(titulo) + '</h2>' +
      (limite && conta.pedidos.length > limite ? '<a class="mc-lnk" href="#pedidos">Ver todos</a>' : '') + '</div>' +
      lista.map(linhaPedido).join('') + '</div>';
  }

  function comprarDeNovo() {
    var vistos = {};
    var itens = [];
    conta.pedidos.forEach(function (p) {
      p.itens.forEach(function (i) {
        if (i.handle && !vistos[i.handle] && itens.length < 8) {
          vistos[i.handle] = 1;
          itens.push(i);
        }
      });
    });
    if (!itens.length) return '';
    return '<div class="mc-card">' +
      '<h2 class="fv-serif mc-h2">Comprar de novo</h2>' +
      '<p class="mc-sub">Os perfumes que você já levou, no tamanho da última compra.</p>' +
      '<div class="mc-tiles" data-mc-tiles>' + itens.map(function (i) {
        return '<div class="mc-tile" data-mc-tile="' + esc(i.handle) + '" data-ml="' + esc(i.ml || '') + '">' +
          '<a class="mc-tile__foto" href="/products/' + encodeURIComponent(i.handle) + '" data-mc-foto="' + esc(i.handle) + '"></a>' +
          '<span class="mc-tile__marca" data-mc-marca></span>' +
          '<a class="mc-tile__nome" href="/products/' + encodeURIComponent(i.handle) + '">' + esc(tituloCurto(i.titulo)) + '</a>' +
          '<span class="mc-tile__preco" data-mc-preco>' + (i.ml ? 'Decant ' + esc(i.ml) + ' ml' : '') + '</span>' +
          '<button type="button" class="mc-btn mc-btn--contorno mc-btn--p" data-mc-add disabled>' + ic(I.sacola, 16) + 'Adicionar</button>' +
          '</div>';
      }).join('') + '</div></div>';
  }

  function tituloCurto(t) {
    return String(t || '')
      .replace(/\s*\(Decant\)\s*/i, ' ')
      .replace(/\s+\d+([.,]\d+)?\s*ml\s*$/i, '')
      .replace(/\s+(Masculino|Feminino|Unissex)\b.*$/i, '')
      .trim();
  }

  function variantePorMl(prod, ml) {
    var vs = (prod && prod.variants) || [];
    var alvo = vs.find(function (v) {
      var t = String(v.title || v.option1 || '').replace(/\s/g, '').toLowerCase();
      return ml && (t === ml + 'ml' || t === String(ml));
    });
    return alvo || vs.find(function (v) { return v.available; }) || vs[0] || null;
  }

  function prepararTiles() {
    principal.querySelectorAll('[data-mc-tile]').forEach(function (tile) {
      var handle = tile.getAttribute('data-mc-tile');
      var ml = tile.getAttribute('data-ml');
      produto(handle).then(function (prod) {
        var botao = tile.querySelector('[data-mc-add]');
        if (!prod) {
          botao.textContent = 'Indisponível';
          return;
        }
        var v = variantePorMl(prod, ml);
        var marca = tile.querySelector('[data-mc-marca]');
        if (marca) marca.textContent = prod.vendor || '';
        if (!v) return;
        var tam = String(v.title || '').replace(/\s*ml$/i, ' ml');
        tile.querySelector('[data-mc-preco]').textContent = 'Decant ' + tam + ' · ' + brl(v.price / 100);
        if (v.available) {
          botao.disabled = false;
          botao.setAttribute('data-variant', v.id);
        } else {
          botao.innerHTML = 'Esgotado';
        }
      });
    });
  }

  function aviso(texto) {
    var velho = document.querySelector('.mc-aviso-flutuante');
    if (velho) velho.remove();
    var el = document.createElement('div');
    el.className = 'mc-aviso-flutuante';
    el.setAttribute('role', 'status');
    el.innerHTML = texto;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 5000);
  }

  function adicionar(botao) {
    var id = botao.getAttribute('data-variant');
    if (!id) return;
    botao.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('sacola'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'fv-minha-conta', data: { source: 'fv-minha-conta', itemCount: cart.item_count } }
        }));
        aviso('Adicionado à sacola. <a href="/cart">Ver sacola</a>');
      })
      .catch(function () { aviso('Não consegui adicionar agora. Tente de novo.'); })
      .then(function () { botao.disabled = false; });
  }

  function perfil(cheio) {
    var p = conta.perfil;
    if (!p) {
      return '<div class="mc-card">' +
        '<div class="mc-cab"><h2 class="fv-serif mc-h2">Seu perfil olfativo</h2><span style="color:#c9a84c">' + ic(I.brilho, 20) + '</span></div>' +
        '<p class="mc-sub">Faça a Curadoria Olfativa e descubra os perfumes que combinam com você. Depois das suas compras, o seu perfil aparece aqui.</p>' +
        '<div class="mc-acoes"><a class="mc-btn mc-btn--escuro mc-btn--p" href="/pages/curadoria-olfativa">Fazer a curadoria</a></div></div>';
    }
    var max = p.familias[0] ? p.familias[0].pct : 100;
    var principalFam = p.familias[0] ? p.familias[0].nome : '';
    return '<div class="mc-card">' +
      '<div class="mc-cab"><h2 class="fv-serif mc-h2">Seu perfil olfativo</h2><span style="color:#c9a84c">' + ic(I.brilho, 20) + '</span></div>' +
      '<p class="mc-sub" style="line-height:1.5">' + esc(p.frase) + '</p>' +
      '<ul class="mc-barras" aria-label="Famílias do seu perfil">' + p.familias.map(function (f) {
        return '<li><span>' + esc(f.nome) + '</span><span class="mc-barras__trilho"><span style="width:' + (f.pct / max * 100).toFixed(1) + '%"></span></span><span>' + f.pct + '%</span></li>';
      }).join('') + '</ul>' +
      (cheio ? '<p class="mc-suave" style="margin-top:16px">Calculado pelos ' + p.perfumes + ' perfumes dos seus pedidos: o acorde principal de cada um pesa mais.</p>' : '') +
      '<div class="mc-acoes"><a class="mc-btn mc-btn--escuro mc-btn--p" href="/collections/decants?filter.p.m.frenesi.acordes=' + encodeURIComponent(principalFam) + '">Ver perfumes ' + esc(principalFam.toLowerCase()) + 's</a>' +
      '<a class="mc-lnk" href="/pages/curadoria-olfativa">Refazer a curadoria</a></div></div>';
  }

  function ajuda() {
    var zap = raiz.getAttribute('data-whatsapp') || '#';
    var numero = raiz.getAttribute('data-whatsapp-numero') || '';
    var horario = raiz.getAttribute('data-horario') || '';
    return '<div class="mc-ajuda"><div style="display:flex;align-items:center;gap:18px"><span class="mc-ajuda__ic">' + ic(I.balao, 22) + '</span>' +
      '<div><p class="fv-serif" style="font-size:21px">Precisa de ajuda com um pedido?</p>' +
      '<p class="mc-suave" style="font-size:14px;margin-top:4px">Fale com a gente no WhatsApp ' + esc(numero) + ', ' + esc(horario.toLowerCase()) + '.</p></div></div>' +
      '<div style="display:flex;flex:none;align-items:center;gap:22px;flex-wrap:wrap"><a class="mc-lnk" href="/pages/politica-de-trocas-e-devolucoes" style="white-space:nowrap">Trocas e devoluções</a>' +
      '<a class="mc-btn mc-btn--escuro mc-btn--p" href="' + esc(zap) + '" target="_blank" rel="noopener">' + ic(I.balao, 16) + 'Chamar no WhatsApp</a></div></div>';
  }

  // ── Faixa escura: título de cada tela ──────────────────────────────────
  function titulo(t, meta, voltar, extra) {
    if (!faixa) return;
    faixa.innerHTML = (voltar ? '<a class="mc-voltar" href="' + voltar[0] + '">' + ic(I.volta, 16, { traco: 2 }) + esc(voltar[1]) + '</a>' : '<p class="mc-olho">Minha conta</p>') +
      '<h1 class="fv-serif mc-faixa__tit">' + t + (extra || '') + '</h1>' +
      '<p class="mc-faixa__meta">' + (meta || '') + '</p>';
  }

  function metaDaConta() {
    var n = conta.pedidos.length;
    var partes = [];
    if (conta.desde) partes.push('Cliente Frenesi desde ' + mesAno(conta.desde));
    if (n) partes.push(n + (n === 1 ? ' pedido' : ' pedidos'));
    return esc(partes.join(' · '));
  }

  // ── Telas ──────────────────────────────────────────────────────────────
  var telas = {
    visao: function () {
      titulo('Olá, <em>' + esc(nome) + '</em>', metaDaConta());
      var atual = conta.pedidos.find(andando) || null;
      return '<div class="mc-duas">' + cartaoPedidoAtual(atual) + cartaoCashback() + '</div>' +
        convidaAvaliar() +
        comprarDeNovo() +
        '<div class="mc-duas mc-duas--topo">' + listaPedidos(3, 'Últimos pedidos') + perfil() + '</div>' +
        ajuda();
    },
    pedidos: function () {
      titulo('Meus pedidos', metaDaConta());
      return listaPedidos(0, 'Todos os pedidos') + ajuda();
    },
    pedido: function (numero) {
      var p = conta.pedidos.find(function (x) { return x.numero === numero; });
      if (!p) return telas.pedidos();
      var r = p.rastreio || null;
      titulo('Pedido ' + esc(p.numero), diaAno(p.compradoEm) + (p.compradoEm ? ', às ' + hora(p.compradoEm) : '') + ' · ' + qtd(p) + (p.pagamento ? ' · ' + pagamento(p.pagamento) : ''),
        ['#pedidos', 'Meus pedidos'], ' ' + chip(p).replace('mc-chip--caminho', 'mc-chip--claro'));

      var envio = r && r.envio && (r.envio.codigo || r.envio.url)
        ? '<div class="mc-envio"><span style="display:flex;align-items:center;gap:10px">' + ic(I.frete, 19) + '<span>' + esc(r.envio.transportadora || 'Transportadora') +
          (r.envio.codigo ? ' · código <b>' + esc(r.envio.codigo) + '</b>' : '') + '</span></span><span class="mc-envio__acoes">' +
          (r.envio.codigo ? '<button type="button" class="mc-mini" data-mc-copiar="' + esc(r.envio.codigo) + '">' + ic(I.copiar, 13, { traco: 2 }) + 'Copiar</button>' : '') +
          (r.envio.url ? '<a class="mc-mini" href="' + esc(r.envio.url) + '" target="_blank" rel="noopener">Site da transportadora' + ic(I.externo, 13, { traco: 2 }) + '</a>' : '') +
          '</span></div>'
        : (r && r.envio && r.envio.entregaLocal ? '<div class="mc-envio"><span style="display:flex;align-items:center;gap:10px">' + ic(I.frete, 19) + 'Entrega local FRENESI</span></div>' : '');

      var hist = r && r.historico && r.historico.length
        ? '<h3 class="mc-h3" style="margin-top:28px">Histórico da entrega</h3><ol class="mc-hist" aria-label="Histórico da entrega">' + r.historico.map(function (e) {
            return '<li><span class="mc-hist__quando"><b>' + esc(diaCurto(e.quando)) + '</b> ' + esc(hora(e.quando)) + '</span><span class="mc-hist__ponto"><i></i></span>' +
              '<span class="mc-hist__texto"><b>' + esc(e.texto) + '</b>' + (e.local ? '<span>' + ic(I.pin, 13) + esc(e.local) + '</span>' : '') + '</span></li>';
          }).join('') + '</ol>'
        : '';

      var cab = r && r.status
        ? (previsao(r)
          ? '<span class="mc-olho-escuro">' + (r.entregueEm ? 'Entrega' : 'Previsão de entrega') + '</span><p class="fv-serif mc-h2" style="margin-top:8px;font-size:30px">' + esc(previsao(r).replace(/^Chega /, '').replace(/^a/, 'A').replace(/^até/, 'Até')) + '</p>'
          : '<span class="mc-olho-escuro">Situação</span><p class="fv-serif mc-h2" style="margin-top:8px;font-size:30px">' + esc(r.status.titulo) + '</p>') +
          (r.status.detalhe ? '<p class="mc-sub">' + esc(r.status.detalhe) + '</p>' : '')
        : '';

      var subtotal = p.itens.reduce(function (s, i) { return s + i.preco * (i.quantidade || 1); }, 0);
      var linhasResumo = '<li><span>Subtotal</span><span>' + brl(subtotal) + '</span></li>' +
        (p.frete != null ? '<li><span>Frete</span><span' + (p.frete === 0 ? ' class="mc-resumo__gratis">Grátis' : '>' + brl(p.frete)) + '</span></li>' : '') +
        (p.desconto ? '<li><span>Descontos</span><span>− ' + brl(p.desconto) + '</span></li>' : '') +
        (p.cashbackUsado ? '<li><span>Cashback usado</span><span>− ' + brl(p.cashbackUsado) + '</span></li>' : '');

      var itens = '<ul class="mc-itens" aria-label="Itens do pedido">' + p.itens.map(function (i) {
        return '<li class="mc-item">' + foto(i.handle, 76) +
          '<span style="min-width:0"><b>' + esc(tituloCurto(i.titulo)) + '</b><small>' + (i.ml ? 'Decant ' + esc(i.ml) + ' ml · ' : '') + (i.quantidade || 1) + (i.quantidade > 1 ? ' unidades' : ' unidade') + '</small></span>' +
          '<span class="mc-item__dir"><b>' + brl(i.preco * (i.quantidade || 1)) + '</b>' + (i.handle ? '<a class="mc-lnk" style="font-size:13px" href="/products/' + encodeURIComponent(i.handle) + '">Comprar de novo</a>' : '') + '</span></li>';
      }).join('') + '</ul>';

      var endereco = p.entrega && (p.entrega.endereco || p.entrega.cidade)
        ? '<div class="mc-card"><h2 class="mc-olho-escuro">Entrega</h2><p class="mc-endereco"><span style="flex:none;margin-top:2px;color:#7a5c14">' + ic(I.pin, 18) + '</span><span>' +
          esc(p.entrega.endereco || '') + (p.entrega.cidade ? '<br>' + esc(p.entrega.cidade) : '') + (p.entrega.cep ? '<br>CEP ' + esc(p.entrega.cep) : '') + '</span></p></div>'
        : '';

      return '<div class="mc-duas mc-duas--topo mc-duas--pedido">' +
        '<div style="display:grid;gap:24px;min-width:0">' +
        (r ? '<div class="mc-card">' + cab + (r.etapas && r.etapas.length ? '<div style="margin-top:26px">' + etapas(r) + '</div>' : '') + envio + hist + '</div>' : '') +
        '<div class="mc-card"><h2 class="fv-serif mc-h2">Itens do pedido</h2>' + itens + '</div></div>' +
        '<div style="display:grid;gap:24px;align-content:start">' +
        '<div class="mc-card"><h2 class="mc-olho-escuro">Resumo</h2><ul class="mc-resumo">' + linhasResumo + '</ul>' +
        (p.total != null ? '<div class="mc-total"><span>Total pago</span><span>' + brl(p.total) + '</span></div>' : '') +
        (p.cashbackGerado ? '<div class="mc-ganho">' + ic(I.cash, 22) + '<span>Este pedido gerou <b>' + brl(p.cashbackGerado) + '</b> de cashback para a sua próxima compra.</span></div>' : '') +
        '</div>' +
        (p.avaliacao
          ? (p.avaliacao.reenvio
            ? '<div class="mc-card mc-avaliar mc-avaliar--col"><h2 class="mc-olho-escuro">Falta pouco para o seu cupom</h2><p class="mc-sub" style="line-height:1.5">As suas notas já estão guardadas. Mande outra foto ou vídeo com os decants à vista: a equipe confere de novo e o cupom chega por e-mail.</p>' +
              '<a class="mc-btn mc-btn--escuro" style="margin-top:16px" href="' + esc(p.avaliacao.link) + '">' + ic(I.estrela, 17) + 'Enviar foto ou vídeo</a></div>'
            : p.avaliacao.avaliado
            ? '<div class="mc-card mc-avaliado">' + ic(I.check, 18, { traco: 2.2 }) + '<span>Pedido avaliado. Obrigado por contar como foi.</span></div>'
            : '<div class="mc-card mc-avaliar mc-avaliar--col"><h2 class="mc-olho-escuro">Sua opinião</h2><p class="mc-sub" style="line-height:1.5">Como foram os perfumes? Com foto ou vídeo dos seus decants, você ganha um cupom para a próxima compra.</p>' +
              '<a class="mc-btn mc-btn--escuro" style="margin-top:16px" href="' + esc(p.avaliacao.link) + '">' + ic(I.estrela, 17) + 'Avaliar pedido</a></div>')
          : '') +
        endereco +
        '<div class="mc-card"><h2 class="mc-olho-escuro">Algo errado?</h2><p class="mc-sub" style="line-height:1.5">Fale com a gente com o número do pedido à mão.</p>' +
        '<div style="display:grid;gap:10px;margin-top:16px"><a class="mc-btn mc-btn--escuro" href="' + esc(raiz.getAttribute('data-whatsapp') || '#') + '" target="_blank" rel="noopener">' + ic(I.balao, 17) + 'Chamar no WhatsApp</a>' +
        '<a class="mc-btn mc-btn--contorno" href="/pages/politica-de-trocas-e-devolucoes">' + ic(I.troca, 17) + 'Trocas e devoluções</a></div></div>' +
        '</div></div>';
    },
    cashback: function () {
      titulo('Cashback', '10% de tudo o que você paga volta como crédito para a próxima compra.');
      var cb = conta.cashback;
      var numeros = '<div class="mc-numeros">' +
        '<div class="mc-card mc-num"><span>Ganho até hoje</span><b>' + brl(cb.ganho) + '</b></div>' +
        '<div class="mc-card mc-num"><span>Já usado</span><b>' + brl(cb.usado) + '</b></div>' +
        '<div class="mc-card mc-num"><span>Por pedido</span><b>até 25%</b></div></div>';
      var regras = '<div class="mc-card"><h2 class="fv-serif mc-h2">Como funciona</h2><ol class="mc-regras">' +
        [['Você compra', '10% do valor pago em toda compra volta para você como crédito.'],
          ['O crédito entra na hora', 'Assim que o pagamento é confirmado, o valor já aparece aqui.'],
          ['Use em até 60 dias', 'Cobre até 25% dos produtos do próximo pedido, junto com cupons, promoções e o desconto do Pix.']].map(function (x, i) {
          return '<li><span class="mc-regras__n">' + (i + 1) + '</span><b>' + x[0] + '</b><span>' + x[1] + '</span></li>';
        }).join('') + '</ol></div>';
      return '<div class="mc-duas">' + cartaoCashback(true) + numeros + '</div>' + regras + extrato('tudo');
    },
    perfil: function () {
      titulo('Perfil olfativo', 'O que os perfumes que você levou dizem do seu gosto.');
      return perfil(true) + comprarDeNovo();
    },
    dados: function () {
      titulo('Dados e endereços', 'O seu cadastro na Frenesi e os endereços das suas compras.');
      return dadosDoCadastro();
    }
    // [dono, 19/10] Sem a tela «Ajuda e trocas» no menu: a ajuda fica no
    // quadro «Precisa de ajuda com um pedido?» da visão geral e dos pedidos.
  };

  // ── Dados e endereços: o cadastro é o do ERP ───────────────────────────
  // O checkout da Frenesi é que vende, e ele liga a compra ao cliente pelo
  // e-mail e pelo CPF; o endereço vai em cada pedido. A agenda de endereços da
  // Shopify não é lida por ninguém, então editar lá não muda nada aqui.
  function dadosDoCadastro() {
    // Sem compra ainda não há cadastro no ERP: mostra o que a conta da loja sabe.
    var c = conta.cadastro || { nome: raiz.getAttribute('data-cliente-nome'), email: raiz.getAttribute('data-cliente-email') };
    var linha = function (rotulo, valor) {
      return '<div><dt>' + rotulo + '</dt><dd>' + (valor ? esc(valor) : '<span class="mc-suave">Não informado</span>') + '</dd></div>';
    };
    var seus = '<div class="mc-card"><h2 class="fv-serif mc-h2">Seus dados</h2><dl class="mc-dl">' +
      linha('Nome', c.nome) + linha('E-mail', c.email) + linha('CPF', c.cpf) + linha('Telefone', c.telefone) +
      linha('Cliente desde', c.desde ? mesAno(c.desde) : '') + '</dl>' +
      '<div class="mc-ganho" style="margin-top:22px">' + ic(I.cash, 22) +
      '<span>Para usar o seu cashback, informe <b>este e-mail e este CPF</b> no checkout.</span></div></div>';

    var corrigir = '<div class="mc-card"><h2 class="mc-olho-escuro">Algo errado?</h2>' +
      '<p class="mc-sub" style="line-height:1.55">Se algum dado do cadastro estiver errado, fale com a gente que a equipe corrige.</p>' +
      '<div style="display:grid;gap:10px;margin-top:16px"><a class="mc-btn mc-btn--escuro" href="' + esc(raiz.getAttribute('data-whatsapp') || '#') + '" target="_blank" rel="noopener">' + ic(I.balao, 17) + 'Chamar no WhatsApp</a></div></div>';

    var ends = conta.enderecos || [];
    var lista = ends.length ? '<ul class="mc-ends">' + ends.map(function (e, i) {
      return '<li><span class="mc-ends__ic">' + ic(I.pin, 18) + '</span>' +
        '<span class="mc-ends__txt"><b>' + esc(e.logradouro || '') + '</b><small>' + esc([e.cidade, e.cep ? 'CEP ' + cep(e.cep) : ''].filter(Boolean).join(' · ')) + '</small></span>' +
        '<span class="mc-ends__uso">' + (i === 0 ? '<span class="mc-chip mc-chip--caminho">Mais recente</span>' : '') +
        '<small>' + (e.vezes > 1 ? e.vezes + ' pedidos · último ' : 'Pedido ') + esc(e.pedido || '') + ' · ' + diaAno(e.quando) + '</small></span></li>';
    }).join('') + '</ul>' : '<p class="mc-suave" style="margin-top:14px">Nenhum endereço ainda: ele aparece aqui depois da primeira compra.</p>';
    var enderecos = '<div class="mc-card"><h2 class="fv-serif mc-h2">Endereços das suas compras</h2>' + lista +
      '<p class="mc-suave" style="margin:16px 0 0">O endereço de entrega é informado a cada compra, no checkout. Com o CEP, ele se completa sozinho.</p></div>';

    return '<div class="mc-duas mc-duas--topo">' + seus + corrigir + '</div>' + enderecos;
  }

  function cep(v) {
    var d = String(v || '').replace(/\D/g, '');
    return d.length === 8 ? d.slice(0, 5) + '-' + d.slice(5) : String(v || '');
  }

  function extrato(filtro) {
    var movs = conta.cashback.movimentos.filter(function (m) {
      return filtro === 'tudo' || (filtro === 'credito' ? m.tipo === 'credito' : m.tipo === 'uso');
    });
    var botoes = [['tudo', 'Tudo'], ['credito', 'Créditos'], ['uso', 'Usos']].map(function (b) {
      return '<button type="button" class="mc-filtro" data-mc-filtro="' + b[0] + '" aria-pressed="' + (b[0] === filtro) + '">' + b[1] + '</button>';
    }).join('');
    var linhas = movs.length ? movs.map(function (m) {
      var mais = m.tipo === 'credito';
      var desc = mais ? (m.manual ? 'Crédito da loja' : 'Cashback' + (m.pedido ? ' do pedido ' + esc(m.pedido) : '')) : 'Usado' + (m.pedido ? ' no pedido ' + esc(m.pedido) : '');
      var estado = !mais ? '' : m.estado === 'disponivel' ? '<span class="mc-chip mc-chip--caminho">Vale até ' + dia(m.validoAte) + '</span>'
        : m.estado === 'usado' ? '<span class="mc-chip mc-chip--neutro">Usado</span>' : '<span class="mc-chip mc-chip--neutro">Venceu em ' + dia(m.validoAte) + '</span>';
      return '<li><span class="mc-extrato__ic' + (mais ? ' mc-extrato__ic--mais' : '') + '">' + ic(mais ? I.cash : I.sacola, 18) + '</span>' +
        '<span class="mc-extrato__data">' + diaAno(m.quando) + '</span><span class="mc-extrato__desc">' + desc + '</span>' +
        '<span class="mc-extrato__estado">' + estado + '</span>' +
        '<span class="mc-extrato__valor' + (mais ? ' mc-extrato__valor--mais' : '') + '">' + (mais ? '+ ' : '− ') + brl(m.valor) + '</span></li>';
    }).join('') : '<li style="display:block;color:rgb(26 23 21/.6)">Nenhum movimento por aqui ainda.</li>';
    return '<div class="mc-card" data-mc-extrato><div class="mc-cab" style="flex-wrap:wrap"><h2 class="fv-serif mc-h2">Extrato</h2><div class="mc-filtros">' + botoes + '</div></div>' +
      '<ul class="mc-extrato" aria-label="Movimentos do cashback">' + linhas + '</ul></div>';
  }

  // ── Navegação ──────────────────────────────────────────────────────────
  function rota() {
    var h = decodeURIComponent(location.hash.replace(/^#/, ''));
    if (h.indexOf('pedido/') === 0) return { tela: 'pedido', arg: h.slice(7) };
    return { tela: telas[h] ? h : 'visao', arg: null };
  }

  function marcarMenu(tela) {
    var alvo = tela === 'pedido' ? 'pedidos' : tela;
    raiz.querySelectorAll('[data-mc-ir]').forEach(function (a) {
      if (a.getAttribute('data-mc-ir') === alvo) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
    // No celular as abas rolam de lado: a aba da tela aberta fica à vista.
    var abas = raiz.querySelector('.mc-abas');
    var ativa = abas && abas.querySelector('[aria-current="page"]');
    if (ativa && abas.scrollWidth > abas.clientWidth) {
      var desvio = ativa.getBoundingClientRect().left - abas.getBoundingClientRect().left;
      abas.scrollLeft = Math.max(0, abas.scrollLeft + desvio - (abas.clientWidth - ativa.offsetWidth) / 2);
    }
  }

  function desenhar(rolar) {
    if (!conta) return;
    var r = rota();
    principal.innerHTML = telas[r.tela](r.arg);
    principal.setAttribute('aria-busy', 'false');
    marcarMenu(r.tela);
    preencherFotos();
    prepararTiles();
    if (rolar) {
      var topo = raiz.getBoundingClientRect().top + window.scrollY - 80;
      if (window.scrollY > topo) window.scrollTo({ top: Math.max(0, topo), behavior: 'smooth' });
    }
  }

  principal.addEventListener('click', function (e) {
    var add = e.target.closest('[data-mc-add]');
    if (add) { adicionar(add); return; }
    var copiar = e.target.closest('[data-mc-copiar]');
    if (copiar) {
      var texto = copiar.getAttribute('data-mc-copiar');
      (navigator.clipboard ? navigator.clipboard.writeText(texto) : Promise.reject())
        .then(function () { copiar.lastChild.textContent = 'Copiado'; setTimeout(function () { copiar.lastChild.textContent = 'Copiar'; }, 2000); })
        .catch(function () { aviso('Código: ' + esc(texto)); });
      return;
    }
    var filtro = e.target.closest('[data-mc-filtro]');
    if (filtro) {
      var caixa = principal.querySelector('[data-mc-extrato]');
      if (caixa) caixa.outerHTML = extrato(filtro.getAttribute('data-mc-filtro'));
    }
  });

  window.addEventListener('hashchange', function () { desenhar(true); });

  // ── Carregar ───────────────────────────────────────────────────────────
  function falhou(semLogin) {
    principal.setAttribute('aria-busy', 'false');
    principal.innerHTML = '<div class="mc-card mc-vazio">' +
      '<p class="fv-serif mc-h2">' + (semLogin ? 'Sua sessão terminou' : 'Não conseguimos abrir os seus pedidos agora') + '</p>' +
      '<p class="mc-sub">' + (semLogin ? 'Entre de novo com o seu e-mail para ver a sua conta.' : 'Tente de novo em instantes. Se continuar, fale com a gente no WhatsApp.') + '</p>' +
      (semLogin
        ? '<a class="mc-btn mc-btn--escuro" href="/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname) + '">Entrar</a>'
        : '<button type="button" class="mc-btn mc-btn--escuro" data-mc-tentar>Tentar de novo</button>') +
      '</div>';
    var tentar = principal.querySelector('[data-mc-tentar]');
    if (tentar) tentar.addEventListener('click', carregar);
  }

  function carregar() {
    principal.setAttribute('aria-busy', 'true');
    if (faixa) faixa.innerHTML = faixaOriginal;
    fetch(raiz.getAttribute('data-proxy') || '/apps/frenesi', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }, function () { return { ok: false, status: r.status, j: null }; });
      })
      .then(function (res) {
        if (!res.ok || !res.j || !res.j.conta) {
          falhou(res.status === 401 && res.j && res.j.erro === 'sem_login');
          return;
        }
        conta = res.j.conta;
        conta.pedidos = conta.pedidos || [];
        var marcaPedidos = raiz.querySelectorAll('[data-mc-marca-pedidos]');
        if (conta.pedidos.some(andando)) marcaPedidos.forEach(function (m) { m.hidden = false; });
        raiz.querySelectorAll('[data-mc-marca-cashback]').forEach(function (m) {
          if (conta.cashback && conta.cashback.saldo > 0) { m.textContent = brl(conta.cashback.saldo); m.hidden = false; }
        });
        desenhar(false);
      })
      .catch(function () { falhou(false); });
  }

  carregar();
})();
